export default __webpack_public_path__ + "static/media/mz.c1b9bea7.svg";